<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <div v-if="loading">
          <loading></loading>
        </div>
      </v-layout>
      <v-layout>
        <v-flex md12>
          <div v-for="item in pruebas" v-bind:key="item.nivel">
            <grafica-documento
              v-if="item.lstDocumentos.length > 0"
              :dataGrafica="item"
            ></grafica-documento>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import API from "@/api";
import Util from "@/util";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Vue from "vue";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import GraficaDocumento from "@/modules/captura/views/seguimiento/evolucionGrafica/GraficaDocumento.vue";

export default {
  name: "documento-tab",

  components: {
    VWidget,
    EChart,
    Loading,
    GraficaDocumento,
  },

  props: {
    //tabSelected: ""
  },

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      gridDocumento: 20,
      indexChart: 0,
      res: [],
      titleGrafica: [],
      titleTest: [],
      pruebas: [],
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
    this.loadData();
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
  },

  methods: {
    async loadFilter() {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/seguimiento/captura/documento/grafica/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadData() {
      this.loading = true;
      //dibujar la grafica
      this.pruebas = await this.loadFilter();
      this.loading = false;
    },
  },
};
</script>
